import { BgColors } from "./types";

export const CONSOLE_STYLE_TITLE = 'font-size: 20px; font-weight: bold; background-color: yellow';
export const CONSOLE_STYLE_SUMMARY = 'font-size: 20px; font-weight: bold; background-color: #ececec';
export const CONSOLE_STYLE_EMPHASIS = 'font-weight: bold; background-color:rgb(255, 152, 152)';
export const CONSOLE_STYLE_ERROR = 'font-weight: bold; background-color:rgb(255, 152, 152)';

export function printWarning(message:string) {
  console.log(`%c${message}`, CONSOLE_STYLE_ERROR);
}
  
export const logMeConsole = (arg: any) => {
  var styleContent = `background-color: orange; color: #fff; border-radius: 10px; margin-right: 5px;`;
  var name = Object.keys(arg)[0];
  console.log('%c %s %O', styleContent, name, arg);
}

export const logMeFnTitle = (fnName: string) => {
  var styleTitle = `background-color: rgb(240,240,240); color: #000; padding: 2px 4px; border-radius: 4px; font-size: 24px; font-weight: 500`;
  console.log(`%c** ${fnName} **`, styleTitle);
}
  